<template>
  <section class="text-root-2">
    <!-- top -->
    <div class="w-full px-5">
      <div class="flex items-center justify-between">
        <!-- balance -->
        <div>
          <p class="font-thin text-xs mb-1">Card balance</p>
          <h3 class="font-bold text-3xl">$452,230</h3>
        </div>
        <!-- manage -->
        <div
          class="flex items-center gap-x-2 bg-primary rounded-lg px-4 py-2.5 cursor-pointer shadow"
        >
          <settings-icon />
          <p class="text-white font-normal text-xs">Manage</p>
        </div>
      </div>
      <!-- cards -->
      <div
        class="mt-8 relative flex flex-nowrap items-center gap-x-4 w-full max-w-xl overflow-x-scroll whitespace-nowrap cards"
      >
        <div
          v-for="x in 3"
          :key="x"
          class="py-5 px-4 rounded-lg w-full shadow-sm relative"
          :class="'bg-' + x"
        >
          <torus-mara-card-logo />
          <p
            class="text-white text-xs font-thin mt-20 flex items-center justify-between gap-x-36"
          >
            <span>ALBERT FLORES</span>
            <span>16/23</span>
          </p>
          <p class="mt-5">
            <span class="text-white text-xs font-thin"
              >**** **** **** 1234</span
            >
          </p>
          <img
            :src="visaLogo"
            class="absolute bottom-0 right-4 object-contain h-14 w-14"
          />
          <img
            :src="lines"
            class="absolute top-1/4 left-0 object-contain w-full h-full"
          />
        </div>
      </div>
      <!-- card options -->
      <div class="flex items-center justify-center gap-x-4 lg:gap-x-8 mt-10">
        <div class="flex flex-col gap-y-2 items-center">
          <div
            class="p-2 md:p-3 border-root-1 bg-surface rounded-lg shadow-xs flex flex-col items-center justify-center"
          >
            <eye-icon color="#1570F2" size="md:h-6 md:w-6 h-4 w-4" />
          </div>
          <p class="font-thin text-xs mb-1">Card Details</p>
        </div>
        <div class="flex flex-col gap-y-2 items-center">
          <div
            class="p-2.5 md:p-4 border-root-1 bg-surface rounded-lg shadow-xs flex items-center justify-center"
          >
            <edit-pen-icon-2 color="#1570F2" size="md:h-4 md:w-4 h-2.5 w-2.5" />
          </div>
          <p class="font-thin text-xs mb-1">Edit Card</p>
        </div>
        <div class="flex flex-col gap-y-2 items-center">
          <div
            class="p-2 md:p-4 border-root-1 bg-surface rounded-lg shadow-xs flex items-center justify-center"
          >
            <freeze-icon size="h-4 w-4 md:h-5 md:w-5" />
          </div>
          <p class="font-thin text-xs mb-1">Freeze Card</p>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <div class="mt-8">
      <p class="flex items-center justify-between py-3 px-10 bg-root-6">
        <span class="text-sm text-root-2 lg:text-base font-semibold"
          >Activities</span
        >
        <span class="text-xs text-primary font-medium">See all</span>
      </p>
      <!-- single activity -->
      <ul class="px-10">
        <li
          v-for="(activity, index) in activities"
          :key="index"
          class="flex items-center w-full my-4"
        >
          <div class="flex gap-x-2 items-center w-full">
            <!-- icon -->
            <div class="bg-surface p-1 rounded">
              <arrow-down v-if="activity.type === $transactionType.DEPOSIT" />
              <arrow-up v-if="activity.type === $transactionType.WITHDRAWAL" />
              <cart-icon v-if="activity.type === 'purchase'" />
            </div>
            <p class="flex flex-col pb-5 w-full">
              <span class="font-normal capitalize text-primary text-sm">{{
                activity.title
              }}</span>
              <span class="text-xs font-light text-root-5">{{
                activity.date
              }}</span>
            </p>
          </div>
          <div>
            <p>
              {{
                (activity.type === $transactionType.DEPOSIT ? '+' : '-') +
                activity.amount
              }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import visaLogo from '@/assets/v2/images/visa-logo.png'
import lines from '@/assets/v2/images/lines.png'
export default {
  name: 'CardDrawerContent',
  components: {
    SettingsIcon: () => import('@/assets/v2/icons/SettingsIcon.vue'),
    TorusMaraCardLogo: () => import('@/assets/v2/icons/TorusMaraCardLogo.vue'),
    EyeIcon: () => import('@/assets/icons/EyeIcon.vue'),
    EditPenIcon2: () => import('@/assets/icons/EditPenIcon2.vue'),
    FreezeIcon: () => import('@/assets/v2/icons/FreezeIcon.vue'),
    ArrowDown: () => import('@/assets/icons/ArrowDown.vue'),
    ArrowUp: () => import('@/assets/icons/ArrowUp.vue'),
    CartIcon: () => import('@/assets/v2/icons/CartIcon.vue')
  },
  data () {
    return {
      visaLogo,
      lines,
      activities: [
        {
          title: 'Figma',
          date: '24 Aug, 6:20 PM',
          amount: '$45',
          type: 'purchase'
        },
        {
          title: this.$transactionType.DEPOSIT,
          date: '24 Aug, 6:20 PM',
          amount: '$45',
          type: this.$transactionType.DEPOSIT
        },
        {
          title: this.$transactionType.DEPOSIT,
          date: '24 Aug, 6:20 PM',
          amount: '$45',
          type: this.$transactionType.DEPOSIT
        }
      ]
    }
  }
}
</script>

<style scoped>
/* .bg-1 {
  background: linear-gradient(180deg, #211f1f 0%, #000000 100%);
  box-shadow: 6.20253px 7.75316px 12.4051px rgba(0, 0, 0, 0.05);
}
.bg-2 {
  background: linear-gradient(45deg, #000f43 0%, #000000 100%);
  box-shadow: 8px 10px 16px rgba(0, 0, 0, 0.05);
}
.bg-3 {
  background: linear-gradient(45deg, #00155f 0%, #010634 100%);
  box-shadow: 8px 10px 16px rgba(0, 0, 0, 0.05);
} */
</style>
